import { render, staticRenderFns } from "./add.dialog.vue?vue&type=template&id=4b33dacb&scoped=true"
import script from "./add.dialog.vue?vue&type=script&lang=js"
export * from "./add.dialog.vue?vue&type=script&lang=js"
import style0 from "./add.dialog.vue?vue&type=style&index=0&id=4b33dacb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33dacb",
  null
  
)

export default component.exports